<!--就诊人列表弹窗--->
<template>
  <a-modal v-model="visible" title="就诊人列表" :footer="null">
    <a-list
      class="demo-loadmore-list"
      item-layout="horizontal"
      :data-source="patientList"
    >
      <a-list-item slot="renderItem" slot-scope="item, index" @click="handleOk(item)">
        <i slot="actions" class="btn">选中</i>
        <a-list-item-meta :description="'证件号：' + item.idNumber">
          <div slot="title" >{{ item.name }}</div>
        </a-list-item-meta>
        <div>{{ item.phone }}</div>
      </a-list-item>
    </a-list>
  </a-modal>
</template>
<script>
import { getListPatients } from "@/api/bac";
export default {
  data() {
    return {
      visible: false,
      patientList: [],
    };
  },

  methods: {
    handleOk(item) {
      this.$emit("changePatient", item);
      this.visible = false;
    },
    //就诊人列表
    async listPatients() {
      const params = {
        userNo: this.userInfo.userNo,
      };
      const { code, data, total } = await getListPatients(params);
      if (code == 200) {
        this.patientList = data;

        if (data && data.length > 0) {
          this.isNo = false;
        } else {
          this.isNo = true;
        }
      } else {
        this.isNo = true;
        this.patientList = [];
      }
    },
    /**开始查询 */
    getList() {
      this.userInfo =
        sessionStorage.getItem("userInfo") &&
        JSON.parse(sessionStorage.getItem("userInfo"));

      this.visible = true;

      this.listPatients();
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.btn{
  cursor: pointer;
  color:#1890ff ;
}
</style>
